import React from 'react';

import { useTranslation } from 'react-i18next';

import { Emoji, StyledEmojiAction } from './styles';

export interface EmojiActionProps {
    glyph: string;
    onAction(): void;
}

export function EmojiAction({ glyph, onAction }: EmojiActionProps) {
    const { t: translate } = useTranslation('emoji');

    return (
        <StyledEmojiAction aria-label={translate('emojiSelect', { glyph })} onClick={onAction}>
            <Emoji>{glyph}</Emoji>
        </StyledEmojiAction>
    );
}
